import { PageTitle } from '@/components/seo/page-title';
import { AdminUsersScreen } from '@/features/admin/screens/admin-users-screen';

export default function AdminUsersRoute() {
  return (
    <>
      <PageTitle title="Admin Users" />
      <AdminUsersScreen />
    </>
  );
}
